import React from 'react';
import ThemeStatus from './ThemeStatus';
import themeResponsiveProperty from './responsive/themeResponsiveProperty';
import { withTheme } from 'styled-components';

export default withTheme(({ status, small, light, ...props }) => (
  <ThemeStatus status={status} {...props} color={light ? '#fff' : null} iconStyle={{
    width: small ? '1.5rem' : '2rem',
  }} />
));
